import styled from '@emotion/styled';
import { useRef } from 'react';

import { useAccessibleInteractivity } from '../../../hooks';
import Theme from '../../../themes';
import Text from '../../OC/oc-text';

const ChildItem = styled.li`
  color: ${props => (props.disabled ? '#666' : 'black')};
  margin-bottom: 10px;
  ${props =>
    props.nested
      ? props.rootShown
        ? 'margin-left: 16px;'
        : 'margin-left: 32px;'
      : ''}
  opacity: ${props => (props.disabled ? '.3' : '1')};

  &:hover {
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }

  &:focus {
    outline: ${props =>
      props.disabled ? 'none' : `${Theme.colors.brand} solid 2px`};
    outline-offset: ${props => (props.disabled ? '0' : '2px')};
  }

  &:focus:not(:focus-visible) {
    outline: none !important;
  }

  &:focus-visible {
    outline: ${props =>
      props.disabled ? 'none' : `${Theme.colors.brand} solid 2px`};
    outline-offset: ${props => (props.disabled ? '0' : '2px')};
  }

  a {
    color: ${props => (props.selected ? Theme.colors.brand : '#333333')};
    font-weight: ${props => (props.selected ? '700' : '500')};
    text-decoration: none;

    &:focus,
    &:focus-visible {
      outline-color: ${Theme.colors.brand};
    }
  }
`;

const ChildListItem = ({
  count,
  disabled,
  name,
  onClick,
  selected,
  nested,
  rootShown,
  slug,
  title,
}) => {
  const linkRef = useRef();
  useAccessibleInteractivity(linkRef, onClick);

  return (
    <ChildItem
      key={slug}
      rootShown={rootShown}
      disabled={disabled}
      selected={selected}
      nested={nested}
    >
      <a
        data-track={selected ? 'remove-filter' : 'filter'}
        data-track-filter-name={title}
        data-track-filter-option={name}
        ref={linkRef}
      >
        <span>
          <Text content={name} />
          {typeof count !== 'undefined' ? <>&nbsp;{`(${count})`}</> : null}
        </span>
      </a>
    </ChildItem>
  );
};

export default ChildListItem;
